import {getHeaders, getMPMEndpoint} from '../../../helpers/endpoint';

export const REQUEST_FETCH_MPM_MATCHES_BADGES =
  'REQUEST_FETCH_MPM_MATCHES_BADGES';
export const SUCCESS_FETCH_MPM_MATCHES_BADGES =
  'SUCCESS_FETCH_MPM_MATCHES_BADGES';
export const FAIL_FETCH_MPM_MATCHES_BADGES = 'FAIL_FETCH_MPM_MATCHES_BADGES';

export const fetchMPMMatchesBadges = (payload, callbacks) => {
  const {onError, onRequest, onSuccess} = callbacks;
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_MPM_MATCHES_BADGES, payload});
    if (onRequest) onRequest(payload);

    fetch(getMPMEndpoint('fetchMPMMatchesBadges', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) dispatch({type: FAIL_FETCH_MPM_MATCHES_BADGES});
        else dispatch({type: SUCCESS_FETCH_MPM_MATCHES_BADGES, data});

        if (onSuccess) onSuccess(data, payload);
      })
      .catch((error, type = FAIL_FETCH_MPM_MATCHES_BADGES) => {
        if (onError) onError(error, type);
        dispatch({type, error});
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/entities/statistics/mpmBadges.js